var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSizingRulerSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 343 85"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path)",
  "data-name": "Mask Group 1225",
  transform: "translate(3003 -1468)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9818"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9814"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "m-2445.774 1539.015-.413-69.724 66.585-.181.115 69.607Z",
  "data-name": "Path 6027"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#b7b8b6",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.3,
  d: "M-2922.23 1538.717h-71.6v-69.733h73.6",
  "data-name": "Path 6028"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#b7b8b6",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.3,
  d: "M-2530.93 1468.983h275.287v69.733h-279.388",
  "data-name": "Path 6029"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fafafa",
  d: "M-2661.027 1469v70h-341.974v-70Z",
  "data-name": "Path 6030"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9815"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2992.886 1552.779a3.4 3.4 0 0 0 3.214-2.291c1.588-3.62 2.324-3.17 4.18-5.753.5-.693 3.1-4.406 4.9-6.984a3.047 3.047 0 0 0-.786-4.268s-5.884 8.383-6.611 9.349c-1.308 1.738-1.029 2.154-2.45 4.186a3.4 3.4 0 1 0-2.445 5.761m6.08-9.547a.673.673 0 1 1-.674.673.67.67 0 0 1 .674-.673m-7.06 5.582a1.186 1.186 0 1 1 .21 1.9 1.386 1.386 0 0 1-.21-1.9",
  "data-name": "Path 6031"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2983.171 1547.018a13 13 0 0 1-1.093-1.837q-.13.185-.206.288a15 15 0 0 1-1.458 1.756 10.6 10.6 0 0 1 1.987 3.263 3.4 3.4 0 1 0 .77-3.47m3.424 1.8a1.186 1.186 0 1 1-1.75-.768 1.384 1.384 0 0 1 1.75.768",
  "data-name": "Path 6032"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2989.496 1542.785c.142-.217.306-.45.5-.709s.725-1 1.419-1.981c-1.967-2.781-4.656-6.612-4.656-6.612a3.05 3.05 0 0 0-.786 4.269c1.1 1.569 2.49 3.559 3.523 5.033",
  "data-name": "Path 6033"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2247.919 1457a3.29 3.29 0 0 0-3.114 2.222c-1.54 3.507-2.252 3.07-4.051 5.574-.483.673-3 4.271-4.747 6.767a2.954 2.954 0 0 0 .762 4.137s5.7-8.124 6.407-9.059c1.267-1.685 1-2.089 2.375-4.059a3.293 3.293 0 1 0 2.368-5.582m-5.887 9.253a.653.653 0 1 1 .653-.652.653.653 0 0 1-.653.652m6.837-5.41a1.34 1.34 0 0 1-1.7.744 1.564 1.564 0 1 1 1.7-.744",
  "data-name": "Path 6034"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2257.333 1462.582a12.3 12.3 0 0 1 1.059 1.783q.127-.181.2-.28a15 15 0 0 1 1.414-1.7 10.3 10.3 0 0 1-1.926-3.161 3.3 3.3 0 1 0-.746 3.36m-3.319-1.741a1.15 1.15 0 1 1 1.7.744 1.34 1.34 0 0 1-1.7-.744",
  "data-name": "Path 6035"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M-2251.206 1466.686c-.137.209-.295.437-.484.687s-.7.97-1.375 1.919c1.906 2.7 4.511 6.408 4.511 6.408a2.955 2.955 0 0 0 .763-4.137z",
  "data-name": "Path 6036"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-2253.18 1467.624v7.042h-11.958v-7.042z",
  "data-name": "Rectangle 25235"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2014.927 -527.888)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2017.722 -525.093)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2020.522 -522.293)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2029.042 -542.003)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2031.836 -539.208)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2034.636 -536.408)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2043.156 -556.118)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2045.951 -553.323)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2048.752 -550.523)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2057.332 -570.293)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 3,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2060.127 -567.498)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "3")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2062.927 -564.698)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2071.507 -584.468)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2074.302 -581.673)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2077.102 -578.873)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2085.706 -598.667)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 5,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2088.501 -595.872)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "5")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2091.301 -593.072)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2099.851 -612.812)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 6,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2102.646 -610.017)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2105.446 -607.217)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2113.996 -626.957)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 7,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2116.791 -624.162)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "7")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2119.591 -621.362)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2128.141 -641.102)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 8,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2130.936 -638.307)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "8")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2133.736 -635.507)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2142.371 -655.332)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 9,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2145.166 -652.537)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "9")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2147.966 -649.737)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2156.601 -669.562)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2159.396 -666.767)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2162.196 -663.967)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2170.746 -683.707)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2173.541 -680.912)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2176.341 -678.112)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2184.837 -697.798)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2187.631 -695.003)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2190.432 -692.203)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2199.067 -712.028)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 3,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2201.862 -709.233)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "3")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2204.662 -706.433)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2213.266 -726.227)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2216.061 -723.432)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2218.861 -720.632)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2220.839 -746.581)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  letterSpacing: ".1em"
}, "m"), /*#__PURE__*/React.createElement("tspan", {
  y: 0
}, "m")), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1a1311",
  strokeMiterlimit: 10,
  "data-name": "Group 9816"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2936.357 1483.174v-13.815m28.351 13.815v-13.815m28.346 13.815v-13.815m28.345 13.815v-13.815m28.348 13.815v-13.815m28.346 13.815v-13.815m28.346 13.815v-13.815m28.347 13.815v-13.815m28.346 13.815v-13.815m28.348 13.815v-13.815m28.344 13.815v-13.815m28.348 13.815v-13.815m28.346 13.815v-13.815m28.347 13.815v-13.815m28.343 13.815v-13.815",
  "data-name": "Path 6037"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2930.689 1479.503v-10.144m28.347 10.144v-10.144m28.346 10.144v-10.144m28.348 10.144v-10.144m28.342 10.146v-10.146m28.345 10.146v-10.146m28.355 10.146v-10.146m28.346 10.146v-10.146m28.345 10.146v-10.146m28.347 10.146v-10.146m28.348 10.146v-10.146m28.345 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m-362.837 10.144v-10.144m28.347 10.144v-10.144m28.348 10.144v-10.144m28.346 10.144v-10.144m28.345 10.146v-10.146m28.346 10.146v-10.146m28.348 10.146v-10.146m28.346 10.146v-10.146m28.345 10.146v-10.146m28.342 10.146v-10.146m28.348 10.146v-10.146m28.352 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m-362.836 10.144v-10.144m28.343 10.144v-10.144m28.35 10.144v-10.144m28.35 10.144v-10.144m28.347 10.146v-10.146m28.346 10.146v-10.146m28.348 10.146v-10.146m28.345 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m-362.838 10.144v-10.144m28.345 10.144v-10.144m28.348 10.144v-10.144m28.346 10.144v-10.144m28.345 10.146v-10.146m28.348 10.146v-10.146m28.341 10.146v-10.146m28.347 10.146v-10.146m28.353 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146",
  "data-name": "Path 6038"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2031.31 -516.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 5,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2067.31 -552.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "5")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 6,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2103.31 -588.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 7,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2139.31 -624.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "7")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 8,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2175.31 -660.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "8")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 9,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -2211.31 -696.735)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "9")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 12,
  fontWeight: 500,
  transform: "rotate(90 -2244.335 -722.701)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  letterSpacing: ".1em"
}, "i"), /*#__PURE__*/React.createElement("tspan", {
  y: 0
}, "n")), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1a1311",
  strokeMiterlimit: 10,
  "data-name": "Group 9817"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2608.842 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6039"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2680.839 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6040"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2752.84 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6041"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2824.84 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6042"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2896.841 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6043"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M-2940.04 1528.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6044"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2544.041 1524.067v14.649",
  "data-name": "Line 3269"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2616.041 1524.067v14.649",
  "data-name": "Line 3270"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2616.041 1524.067v14.649",
  "data-name": "Line 3271"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2688.04 1524.067v14.649",
  "data-name": "Line 3272"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2760.04 1524.067v14.649",
  "data-name": "Line 3273"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2832.039 1524.067v14.649",
  "data-name": "Line 3274"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2904.039 1524.067v14.649",
  "data-name": "Line 3275"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M-2616.041 1524.067v14.649",
  "data-name": "Line 3276"
}))))));
export { SvgSizingRulerSmall as ReactComponent };
export default "/_next/static/images/sizing-ruler-small.svg";